(ns nosco.sentry
  (:require ["@sentry/react" :as sentry]
            [shadow.resource :as rc]
            [clojure.string :as string]))

(def version (string/trim (rc/inline "VERSION")))

(goog-define INIT-SENTRY false)

(when INIT-SENTRY
  (sentry/init
    (cond->
      {:release (str version)
       :normalizeDepth 10
       :integrations (fn [integrations]
                       ;; Remove global handlers so that we can install our own
                       (.filter integrations
                                (fn [^js i]
                                  (not (contains? #{"GlobalHandlers" #_"TryCatch"}
                                                  (.-name i))))))
       :dsn "https://89b6150e76b14f1e9c55c2ebd324f653@o408053.ingest.sentry.io/5281778"}
      goog.DEBUG
      (assoc :environment "development")
      true
      (clj->js)))

  (sentry/setTag "nosco-site" (-> js/document.location .-hostname)))

(defn set-current-user [user-id]
  (sentry/setUser #js {:id user-id}))

(defn set-route-name [route-name]
  (sentry/configureScope
    (fn [^js scope]
      (.setTransactionName scope (str route-name)))))

(defn capture-exception [err]
  (let [event-id (sentry/captureException err)]
    event-id))

(defn capture-message [msg]
  (let [event-id (sentry/captureMessage msg)]
    event-id))

(defn add-breadcrumb [data {:keys [type category]}]
  (sentry/addBreadcrumb #js {:data data
                             :category (if category (name category) js/undefined)
                             :type (if type (name type) js/undefined)}))

(defn add-navigation [from to]
  (sentry/addBreadcrumb #js {:type "navigation"
                             :category "navigation"
                             :data #js {:from from
                                        :to to}}))


#_
(defn with-tag [k v f]
  (let [error-id (atom nil)]
    (sentry/withScope
      (fn [^js scope]
        (.setTag scope k v)
        (reset! error-id (f))))
    @error-id))
